import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
})
export class NotFoundComponent implements OnInit {
    constructor(public menu: MenuServiceInt) {
        // this.menu.display = true;
    }

    ngOnInit() {}
}
